import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  getDashboardData,
  getLiveShipment,
  getDispatchShipment,
  markCompleteShipment,
  getTeamMembers,
  getAllShipment,
  getAllDriver,
  getShipment,
  addDispatchShipment,
  getShippingLineList,
} from '../../ApiController/ApiService';
import { useDashboard } from '../Context/Dashboardcontext';
import DispatchTable from './DispatchManagement/DispatchTable';
import StatsCards from './DispatchManagement/StatsCards';
import ShipmentDetailModal from './DispatchManagement/ShipmentDetailModal';
import DispatchAssignmentPanel from './DispatchManagement/DispatchAssignmentPanel';
import ExportDispatchModal from './DispatchManagement/ExportDispatchModal';
import LTLDispatchModal from './DispatchManagement/LTLDispatchModal';
import FTLDispatchModal from './DispatchManagement/FTLDispatchModal';
import LiveRouteMonitoring from './DispatchManagement/LiveRouteMonitoring';

// Sub-components


const Dispatch = () => {
  const { t, i18n } = useTranslation();
  const { userProfile } = useDashboard();
  const navigate = useNavigate();

  // ─── Calendar / Filter State ────────────────────────────────────────────
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  const calendarRef = useRef(null);
  const buttonRef = useRef(null);
  const buttonRef2 = useRef(null);
  const buttonRef3 = useRef(null);
  const dropdownRef = useRef(null);
  const dropdownRef2 = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedRegions1, setSelectedRegions1] = useState([]);

  // ─── Dashboard / Shipment Data ──────────────────────────────────────────
  const [dashboardData, setDashboardData] = useState({});
  const [shipments3, setShipments3] = useState([]);  // live shipments
  const [data, setData] = useState([]);               // dispatch table rows
  const [shipments, setShipments] = useState([]);     // all shipments (for container select)
  const [shippingLines, setShippingLines] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [users, setUsers] = useState({});

  // ─── Pagination ─────────────────────────────────────────────────────────
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);

  // ─── Loading / Error ────────────────────────────────────────────────────
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState(null);

  // ─── Modal Visibility ───────────────────────────────────────────────────
  const [showModal2, setShowModal2] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showLTLModal, setShowLTLModal] = useState(false);
  const [showFTLModal, setShowFTLModal] = useState(false);

  // ─── Shipment / Driver Selection ────────────────────────────────────────
  const [selectedShipment, setSelectedShipment] = useState(null);
  const [selectedShipments, setSelectedShipments] = useState(null);
  const [selectedType, setSelectedType] = useState('');
  const [selectedShipping, setSelectedShipping] = useState('');
  const [selectedContainer, setSelectedContainer] = useState('');
  const [selectedContainers, setSelectedContainers] = useState([]);
  const [selectedContainerRaw, setSelectedContainerRaw] = useState(null);
  const [selectedContainersRaw, setSelectedContainersRaw] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [availableDriversCount, setAvailableDriversCount] = useState(0);
  const [showDropdowns, setShowDropdowns] = useState(false);
  const [search, setSearch] = useState('');
  const [distance, setDistance] = useState('');

  // ─── Form Data ──────────────────────────────────────────────────────────
  const [formData, setFormData] = useState({
    ltl: {
      shippingMethod: '', shippingMethod1: '', pickEmpty: '', sl: '', size: '',
      loadDate: '', loadTime: '', loadAddress: '', commodity: '', returnFull: '',
      trailerNumber: '', bookingNumber: '', destination: '', pinNumber: '',
      importLocation: '', poNumber: '', flatBeds: '', sealNumber: '',
      dispatchMode: '',
      intermediateDestinations: [{ destination: '', time: '', stopType: '' }],
    },
    ftl: {
      shippingMethod: '', shippingMethod1: '', pickEmpty: '', sl: '', size: '',
      loadDate: '', loadTime: '', loadAddress: '', commodity: '', returnFull: '',
      trailerNumber: '', bookingNumber: '', destination: '', pinNumber: '',
      importLocation: '', poNumber: '', flatBeds: '', sealNumber: '',
      dispatchMode: '',
      intermediateDestinations: [{ destination: '', time: '', stopType: '' }],
    },
    export: {
      sl: '', loadDate: '', loadTime: '', loadAddress: '', destination: '',
      dispatchMode: '', bookingNumber: '',
      containers: [{ size: '', pickEmpty: '', commodity: '', returnFull: '', poNumber: '' }],
      intermediateDestinations: [{ destination: '', time: '' }],
    },
    import: {
      sl: '', size: '', pinNumber: '', importLocation: '', poNumber: '',
      loadDate: '', loadTime: '', loadAddress: '', destination: '', commodity: '',
      returnFull: '', dispatchMode: '',
      intermediateDestinations: [{ destination: '', time: '' }],
    },
  });

  // ─── Helpers ────────────────────────────────────────────────────────────
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
  };

  const isValidDate = (dateString) => {
    if (!dateString) return true;
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regex)) return false;
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date);
  };

  function removeEmpty(obj) {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, v]) => {
          if (v === null || v === undefined) return false;
          if (typeof v === 'string' && v.trim() === '') return false;
          if (Array.isArray(v) && v.length === 0) return false;
          if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return false;
          return true;
        })
        .map(([k, v]) => {
          if (typeof v === 'object' && !Array.isArray(v)) return [k, removeEmpty(v)];
          if (Array.isArray(v)) {
            return [
              k,
              v.map(item => (typeof item === 'object' ? removeEmpty(item) : item))
                .filter(item => {
                  if (item === null || item === undefined) return false;
                  if (typeof item === 'string' && item.trim() === '') return false;
                  if (typeof item === 'object' && Object.keys(item).length === 0) return false;
                  return true;
                }),
            ];
          }
          return [k, v];
        })
    );
  }

  // ─── Data Fetching ──────────────────────────────────────────────────────
  useEffect(() => {
    const fetchShipments = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        if (!token) return;
        const data = await getLiveShipment(token);
        const datas = data?.docs || [];
        const filteredClients = userProfile?.aiPackageId
          ? datas
          : datas.filter(client => client?.companyType === 'Dispax');
        setShipments3(filteredClients || []);
      } catch (err) {
        console.error('Error fetching live shipments:', err);
        if (err.message && (err.message.includes('404') || err.message.toLowerCase().includes('not found'))) {
          setShipments3([]);
        } else {
          setError(t('errors.fetchShipmentsFailed'));
          Swal.fire({ icon: 'error', title: t('errors.error'), text: t('errors.fetchShipmentsFailed'), timer: 2000, showConfirmButton: false });
        }
      }
    };
    fetchShipments();
  }, [t, userProfile]);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const members = await getTeamMembers();
        setTeamMembers(members || []);
      } catch (err) {
        console.error('Failed to fetch team members:', err);
      }
    };
    fetchTeamMembers();
  }, [t]);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const dashboardInfo = await getDashboardData();
        setDashboardData(dashboardInfo || {});
      } catch (err) {
        console.error('Failed to fetch dashboard data:', err);
      }
    };
    fetchDashboard();
  }, [t]);

  const fetchDispatchShipments = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getDispatchShipment({ type: '', page: currentPage, limit: '10', origin: '', status: '' });
      if (!response || !response.docs) {
        setData([]);
        setTotalDocs(0);
        return;
      }

      const shipmentRows = response.docs.map(shipment => ({
        id: shipment.Id,
        order: shipment.orderId,
        type: shipment.goodsType,
        origin: shipment.origin,
        destination: shipment.destination,
        eta: shipment.extimateDeliveryDate ? new Date(shipment.extimateDeliveryDate).toLocaleDateString(i18n.language) : 'N/A',
        status: shipment.status,
        _id: shipment._id,
        userId: shipment.userId,
        driverId: shipment.driverId,
        acceptedId: shipment.acceptedId,
        ...shipment,
      }));
      const userMap = {};
      response.docs.forEach(shipment => {
        if (shipment.userId && shipment.userId._id) userMap[shipment.userId._id] = shipment.userId;
      });
      setUsers(userMap);
      setData(shipmentRows);
      setTotalDocs(response.totalDocs || 0);
      setHasPrevPage(response.hasPrevPage || false);
      setHasNextPage(response.hasNextPage || false);
    } catch (err) {
      console.error('Error fetching dispatch shipments:', err);
      if (err.message && (err.message.includes('404') || err.message.toLowerCase().includes('not found'))) {
        setData([]);
        setTotalDocs(0);
        setHasPrevPage(false);
        setHasNextPage(false);
      } else {
        setError(t('errors.fetchShipmentsFailed'));
        Swal.fire({ icon: 'error', title: t('errors.error'), text: t('errors.fetchShipmentsFailed'), timer: 2000, showConfirmButton: false });
      }
    } finally {
      setLoading(false);
    }
  }, [currentPage, t, i18n.language]);

  useEffect(() => { fetchDispatchShipments(); }, [fetchDispatchShipments]);

  useEffect(() => {
    const fetchInitialData = async () => {
      setIsLoading(true);
      try {
        const shipmentsData = await getAllShipment();
        setShipments(shipmentsData?.docs || []);
      } catch (error) {
        console.error('Error fetching all shipments:', error);
        if (error.message && (error.message.includes('404') || error.message.toLowerCase().includes('not found'))) {
          setShipments([]);
        }
      }
      
      try {
        const lines = await getShippingLineList();
        setShippingLines((lines || []).map((line, index) => ({ id: index + 1, name: line })));
      } catch (error) {
        console.error('Error fetching shipping lines:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchInitialData();
  }, [t]);

  useEffect(() => {
    if (!selectedContainerRaw || !distance) return;
    const coords = selectedContainerRaw?.currentLocation?.coordinates;
    const lng = coords?.[0];
    const lat = coords?.[1];
    if (!lat || !lng) {
      toast.warning('Pickup location not available for selected container');
      return;
    }
    const fetchDrivers = async () => {
      try {
        const driversResponse = await getAllDriver(1, 100, 'Active', '', '', lng, lat, Number(distance));
        setDrivers(driversResponse?.data?.docs || []);
        setAvailableDriversCount(driversResponse?.data?.totalDocs || 0);
      } catch (error) {
        console.error(error);
      }
    };
    fetchDrivers();
  }, [selectedContainerRaw, distance, t]);

  // ─── Booking Number Auto-fill ────────────────────────────────────────────
  useEffect(() => {
    let debounceTimer;
    if (formData.export.bookingNumber) {
      debounceTimer = setTimeout(async () => {
        try {
          const response = await getDispatchShipment({ bookingNumber: formData.export.bookingNumber });
          if (response && response.docs && response.docs.length > 0) {
            const autofilledContainers = response.docs.map(shipment => ({
              _id: shipment._id,
              bookingNumber: shipment.bookingNumber || shipment.poNumber || formData.export.bookingNumber,
              poNumber: shipment.poNumber || shipment.bookingNumber || formData.export.bookingNumber,
              size: shipment.size || '',
              pickEmpty: shipment.pickEmpty || '',
              commodity: shipment.commodity || '',
              returnFull: shipment.returnFull || '',
              appointmentPin: shipment.appointmentPin || '',
            }));
            setFormData(prev => ({ ...prev, export: { ...prev.export, containers: autofilledContainers } }));
          } else {
            setFormData(prev => ({
              ...prev,
              export: {
                ...prev.export,
                containers: [{ _id: null, bookingNumber: '', poNumber: '', size: '', pickEmpty: '', commodity: '', returnFull: '', appointmentPin: '' }],
              },
            }));
          }
        } catch (error) {
          console.error('Error fetching shipments for booking number:', error);
        }
      }, 500);
    }
    return () => { if (debounceTimer) clearTimeout(debounceTimer); };
  }, [formData.export.bookingNumber]);

  // ─── Handlers ───────────────────────────────────────────────────────────
  const handleInputChange = (e, index, dispatchType) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updatedForm = { ...prev };
      if (name.startsWith('intermediateDestinations')) {
        const [, , subField] = name.split('.');
        const newIntermediate = [...updatedForm[dispatchType.toLowerCase()].intermediateDestinations];
        newIntermediate[index] = { ...newIntermediate[index], [subField]: value };
        updatedForm[dispatchType.toLowerCase()].intermediateDestinations = newIntermediate;
      } else if (name.startsWith('containers.')) {
        if (dispatchType === 'Export') {
          const [, idx, subField] = name.split('.');
          const newContainers = [...updatedForm.export.containers];
          newContainers[parseInt(idx)][subField] = value;
          updatedForm.export.containers = newContainers;
        }
      } else {
        updatedForm[dispatchType.toLowerCase()][name] = value;
      }
      return updatedForm;
    });
  };

  const handleContainerSelect = async (containerNumber) => {
    setSelectedContainer(containerNumber);
    if (containerNumber) {
      const selectedShip = shipments.find(s => s.containerNumber === containerNumber);
      if (selectedShip) {
        try {
          const fullShipment = await getShipment(selectedShip._id);
          if (!fullShipment) throw new Error('No shipment data received');
          setSelectedType(fullShipment.importExportType === 'import' ? 'Import' : 'Export');
          const typeLower = fullShipment.importExportType.toLowerCase();
          setFormData(prev => ({
            ...prev,
            [typeLower]: {
              ...prev[typeLower],
              shippingMethod: fullShipment.shippingMethod || '',
              shippingMethod1: fullShipment.shippingMethod1 || '',
              pickEmpty: fullShipment.pickEmpty || '',
              sl: fullShipment.sl || '',
              size: fullShipment.size || '',
              loadDate: formatDateForInput(fullShipment.loadDate),
              loadTime: fullShipment.loadTime || '',
              loadAddress: fullShipment.loadAddress || '',
              commodity: fullShipment.commodity || '',
              returnFull: fullShipment.returnFull || '',
              trailerNumber: fullShipment.trailerNumber || '',
              bookingNumber: fullShipment.bookingNumber || '',
              destination: fullShipment.destination || '',
              pinNumber: fullShipment.pinNumber || '',
              importLocation: fullShipment.importLocation || '',
              poNumber: fullShipment.poNumber || '',
              flatBeds: fullShipment.flatBeds || '',
              sealNumber: fullShipment.sealNumber || '',
              intermediateDestinations: fullShipment.intermediateDestinations || [{ destination: '', time: '' }],
            },
          }));
        } catch (error) {
          console.error('Error fetching shipment details:', error);
          Swal.fire({ icon: 'error', title: t('errors.error'), text: t('errors.fetchShipmentDetailsFailed'), timer: 3000 });
        }
      }
    }
  };

  const handleContainersSelect = (selectedOptions) => {
    setSelectedContainers(selectedOptions);
    setFormData(prev => ({
      ...prev,
      export: {
        ...prev.export,
        containers: selectedOptions.map(containerNumber => {
          const shipment = shipments.find(s => s.containerNumber === containerNumber);
          return {
            bookingNumber: shipment?.bookingNumber || '',
            size: shipment?.size || '',
            pickEmpty: shipment?.pickEmpty || '',
            commodity: shipment?.commodity || '',
            returnFull: shipment?.returnFull || '',
          };
        }),
      },
    }));
  };

  const handleTypeSelect = (type) => {
    setSelectedType(type);
    if (type === 'Export') setShowExportModal(true);
    else if (type === 'Import') {
      if (!selectedContainer) { Swal.fire(t('errors.error'), t('errors.selectContainer'), 'info'); return; }
      setShowImportModal(true);
    } else if (type === 'LTL') setShowLTLModal(true);
    else if (type === 'FTL') setShowFTLModal(true);
  };

  const addContainer = () => {
    setFormData(prev => ({
      ...prev,
      export: { ...prev.export, containers: [...prev.export.containers, { bookingNumber: '', size: '', pickEmpty: '', commodity: '', returnFull: '' }] },
    }));
  };

  const removeContainer = (index) => {
    setFormData(prev => ({
      ...prev,
      export: { ...prev.export, containers: prev.export.containers.filter((_, i) => i !== index) },
    }));
  };

  const addIntermediateDestination = (dispatchType) => {
    setFormData(prev => ({
      ...prev,
      [dispatchType.toLowerCase()]: {
        ...prev[dispatchType.toLowerCase()],
        intermediateDestinations: [...prev[dispatchType.toLowerCase()].intermediateDestinations, { destination: '', time: '' }],
      },
    }));
  };

  const removeIntermediateDestination = (index, dispatchType) => {
    setFormData(prev => ({
      ...prev,
      [dispatchType.toLowerCase()]: {
        ...prev[dispatchType.toLowerCase()],
        intermediateDestinations: prev[dispatchType.toLowerCase()].intermediateDestinations.filter((_, i) => i !== index),
      },
    }));
  };

  const handleViewClick = async (shipmentId) => {
    try {
      setModalLoading(true);
      setModalError(null);
      if (!shipmentId) throw new Error('Shipment ID is required');
      const shipmentData = await getShipment(shipmentId);
      if (!shipmentData) throw new Error('No shipment data received');
      const driverName = shipmentData.acceptedId?.fullName || 'N/A';
      const customer = users[shipmentData.userId] || { fullName: 'N/A' };
      setSelectedShipment({
        ...shipmentData,
        id: shipmentData.Id,
        order: shipmentData.orderId,
        type: shipmentData.goodsType,
        origin: shipmentData.origin,
        destination: shipmentData.destination,
        eta: shipmentData.extimateDeliveryDate ? new Date(shipmentData.extimateDeliveryDate).toLocaleDateString(i18n.language) : 'N/A',
        status: shipmentData.status,
        driverName,
        driverDetails: shipmentData.acceptedId || null,
        customerName: customer.fullName,
      });
      setShowModal2(true);
    } catch (err) {
      console.error('Error loading shipment details:', err);
      setModalError(t('errors.fetchShipmentDetailsFailed'));
      Swal.fire({ icon: 'error', title: t('errors.error'), text: t('errors.fetchShipmentDetailsFailed'), timer: 2000, showConfirmButton: false });
    } finally {
      setModalLoading(false);
    }
  };

  const handleSubmit = async (e, dispatchType) => {
    e.preventDefault();
    if (formData[dispatchType.toLowerCase()].loadDate && !isValidDate(formData[dispatchType.toLowerCase()].loadDate)) {
      Swal.fire(t('errors.error'), t('errors.invalidDate'), 'error');
      return;
    }
    try {
      let shipmentsPayload = [];
      let shipmentId = '';
      if (dispatchType === 'Import' && selectedContainer) {
        const selectedShip = shipments.find(s => s.containerNumber === selectedContainer);
        if (!selectedShip) throw new Error(t('errors.noShipmentFound'));
        shipmentId = selectedShip._id;
      } else if (dispatchType === 'Export') {
        shipmentsPayload = formData.export.containers.map(c => c._id).filter(Boolean);
        if (shipmentsPayload.length === 0) {
          shipmentsPayload = selectedContainers.map(cn => shipments.find(s => s.containerNumber === cn)?._id).filter(Boolean);
        }
        if (shipmentsPayload.length === 1) { shipmentId = shipmentsPayload[0]; shipmentsPayload = []; }
      }
      const dispatchMode = formData[selectedType.toLowerCase()]?.dispatchMode;
      let payload = {
        shipmentId, shipments: shipmentsPayload, dispatchType: selectedShipping, dispatchMode,
        importExportType: (dispatchType === 'Import' || dispatchType === 'Export' ? dispatchType.toLowerCase() : 'Disptach'),
        shippingMethod: formData[dispatchType.toLowerCase()].shippingMethod,
        shippingMethod1: formData[dispatchType.toLowerCase()].shippingMethod1,
        status: 'Pending',
        commodity: formData[dispatchType.toLowerCase()].commodity,
        origin: formData[dispatchType.toLowerCase()].loadAddress || 'Los Angeles, CA',
        driverId: selectedDriver?._id || '',
        size: formData[dispatchType.toLowerCase()].size || null,
        returnFull: formData[dispatchType.toLowerCase()].returnFull,
        loadTime: formData[dispatchType.toLowerCase()].loadTime,
        loadAddress: formData[dispatchType.toLowerCase()].loadAddress,
        loadDate: formData[dispatchType.toLowerCase()].loadDate ? new Date(formData[dispatchType.toLowerCase()].loadDate).toISOString() : null,
        trailerNumber: (dispatchType === 'LTL' || dispatchType === 'FTL') ? formData[dispatchType.toLowerCase()].trailerNumber : null,
        bookingNumber: formData[dispatchType.toLowerCase()].bookingNumber,
        destination: formData[dispatchType.toLowerCase()].destination,
        pinNumber: formData[dispatchType.toLowerCase()].pinNumber,
        importLocation: formData[dispatchType.toLowerCase()].importLocation,
        poNumber: formData[dispatchType.toLowerCase()].poNumber,
        flatBeds: formData[dispatchType.toLowerCase()].flatBeds,
        sealNumber: formData[dispatchType.toLowerCase()].sealNumber,
        sl: formData[dispatchType.toLowerCase()].sl,
        intermediateDestinations: formData[dispatchType.toLowerCase()].intermediateDestinations
          .map(stop => ({ destination: stop.destination, time: stop.time, stopType: stop.stopType || '' }))
          .filter(stop => stop.destination && stop.time),
      };
      payload = removeEmpty(payload);
      await addDispatchShipment(payload);
      Swal.fire({ icon: 'success', title: t('orders.successfully'), text: t(`orders.create${dispatchType}Dispatch`), timer: 2000, showConfirmButton: false });
      setShowExportModal(false); setShowImportModal(false); setShowLTLModal(false); setShowFTLModal(false);

      // Reset form
      const emptyForm = {
        shippingMethod: '', shippingMethod1: '', pickEmpty: '', sl: '', size: '',
        loadDate: '', loadTime: '', loadAddress: '', commodity: '', returnFull: '',
        trailerNumber: '', bookingNumber: '', destination: '', pinNumber: '',
        importLocation: '', poNumber: '', flatBeds: '', sealNumber: '', dispatchMode: '',
        intermediateDestinations: [{ destination: '', time: '', stopType: '' }],
        ...(dispatchType === 'Export' ? { containers: [{ bookingNumber: '', size: '', pickEmpty: '', commodity: '', returnFull: '' }] } : {}),
      };
      setFormData(prev => ({ ...prev, [dispatchType.toLowerCase()]: emptyForm }));
      setSelectedContainer(''); setSelectedContainers([]); setSelectedDriver(null); setSelectedType(''); setSelectedShipping('');
      try {
        const shipmentsData = await getAllShipment();
        setShipments(shipmentsData.docs || []);
      } catch (refreshError) { console.error('Error refreshing shipments:', refreshError); }
    } catch (error) {
      console.error(`Error creating ${dispatchType} dispatch:`, error);
      let errorMessage = t('errors.createDispatchFailed', { dispatchType });
      if (error.response?.data?.errors) {
        errorMessage = Object.entries(error.response.data.errors).map(([field, err]) => `${field}: ${err.message || err}`).join('\n');
      } else if (error.message) {
        errorMessage = t('errors.error', { message: error.message });
      }
      Swal.fire(t('errors.error'), errorMessage, 'error');
    }
  };

  // ─── Click Outside Handlers ──────────────────────────────────────────────
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target) && !buttonRef.current?.contains(event.target)) {
        setShowCalendar(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target) && !buttonRef2.current?.contains(e.target)) setShowDropdown(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef2.current && !dropdownRef2.current.contains(e.target) && !buttonRef3.current?.contains(e.target)) setShowDropdown2(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredDrivers = drivers.filter(driver => {
    const driverName = (driver.fullName || '').toLowerCase();
    return driverName.includes(search.toLowerCase()) || (driver._id && driver._id.toLowerCase().includes(search.toLowerCase()));
  });

  const sharedModalProps = {
    formData,
    handleInputChange,
    handleSubmit,
    addIntermediateDestination,
    removeIntermediateDestination,
    isLoading,
  };

  return (
    <div className="text-white relative">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold">{t('dashboard.dispatchManagement')}</h1>
      </div>

      {/* Stats Cards */}
      <StatsCards dashboardData={dashboardData} />

      {/* Dispatch Table */}
      <DispatchTable
        data={data}
        currentPage={currentPage}
        totalDocs={totalDocs}
        hasPrevPage={hasPrevPage}
        hasNextPage={hasNextPage}
        modalLoading={modalLoading}
        onViewClick={handleViewClick}
        onPrevPage={() => hasPrevPage && setCurrentPage(p => p - 1)}
        onNextPage={() => hasNextPage && setCurrentPage(p => p + 1)}
      />

      {/* Shipment Detail Modal */}
      <ShipmentDetailModal
        show={showModal2}
        selectedShipment={selectedShipment}
        modalLoading={modalLoading}
        modalError={modalError}
        onClose={() => setShowModal2(false)}
      />

      {/* Dispatch Assignment Panel */}
      <DispatchAssignmentPanel
        availableDriversCount={availableDriversCount}
        formData={formData}
        setFormData={setFormData}
        handleInputChange={handleInputChange}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        selectedShipping={selectedShipping}
        setSelectedShipping={setSelectedShipping}
        selectedContainer={selectedContainer}
        setSelectedContainer={setSelectedContainer}
        handleContainerSelect={handleContainerSelect}
        selectedContainers={selectedContainers}
        setSelectedContainers={setSelectedContainers}
        handleContainersSelect={handleContainersSelect}
        setSelectedContainerRaw={setSelectedContainerRaw}
        setSelectedContainersRaw={setSelectedContainersRaw}
        shipments={shipments}
        isLoading={isLoading}
        selectedDriver={selectedDriver}
        setSelectedDriver={setSelectedDriver}
        showDropdowns={showDropdowns}
        setShowDropdowns={setShowDropdowns}
        search={search}
        setSearch={setSearch}
        filteredDrivers={filteredDrivers}
        distance={distance}
        setDistance={setDistance}
        handleTypeSelect={handleTypeSelect}
        setShowExportModal={setShowExportModal}
        setShowImportModal={setShowImportModal}
        setShowLTLModal={setShowLTLModal}
        setShowFTLModal={setShowFTLModal}
      />

      {/* Export Modal */}
      <ExportDispatchModal
        show={showExportModal}
        onClose={() => setShowExportModal(false)}
        shippingLines={shippingLines}
        addContainer={addContainer}
        removeContainer={removeContainer}
        {...sharedModalProps}
      />

      {/* LTL Modal */}
      <LTLDispatchModal
        show={showLTLModal}
        onClose={() => setShowLTLModal(false)}
        setFormData={setFormData}
        {...sharedModalProps}
      />

      {/* FTL Modal */}
      <FTLDispatchModal
        show={showFTLModal}
        onClose={() => setShowFTLModal(false)}
        {...sharedModalProps}
      />

      {/* Calendar Picker */}
      {showCalendar && (
        <div
          ref={calendarRef}
          className="absolute z-10 bg-white p-4 rounded shadow-lg"
          style={{ top: calendarPosition.top, left: calendarPosition.left }}
        >
          <DayPicker mode="multiple" selected={selectedDates} onSelect={setSelectedDates} showOutsideDays />
        </div>
      )}

      {/* Live Route Monitoring */}
      <LiveRouteMonitoring
        shipments3={shipments3}
        onViewClick={handleViewClick}
        selectedShipments={selectedShipments}
        setSelectedShipments={setSelectedShipments}
      />
    </div>
  );
};

export default Dispatch;
